// extracted by mini-css-extract-plugin
export var Breadcrumb = "PressRelease-module--Breadcrumb--dCqkD";
export var BreadcrumbContainer = "PressRelease-module--BreadcrumbContainer--1ZrkY";
export var ContentWrap = "PressRelease-module--ContentWrap--2glje";
export var Content = "PressRelease-module--Content--1e9N3";
export var DateAndSocialContainer = "PressRelease-module--DateAndSocialContainer--37tg3";
export var Date = "PressRelease-module--Date--td3t2";
export var RelatedPressContainer = "PressRelease-module--RelatedPressContainer--29TQS";
export var Title = "PressRelease-module--Title--11tBE";